import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { DataService } from '../../auth/DataService';

function MediaCard({ image, header, to, auth }) {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const userRoles = DataService.getUserRoles();
    if (userRoles) {
      const access = auth
        ? auth.some((role) => userRoles.includes(role))
        : true;
      setHasAccess(access);
    }
  }, [auth]);

  const cardStyle = {
    aspectRatio: 16 / 9,
    cursor: hasAccess ? 'pointer' : 'default',
    border: isHovered ? '4px solid #008DFC' : 'none',
    filter: hasAccess ? 'none' : 'grayscale(100%)',
    pointerEvents: hasAccess ? 'auto' : 'none',
  };

  const overlayStyle = {
    position: 'absolute',
    top: '10%',
    left: '8%',
    textAlign: 'left',
    color: '#FFFFFF',
    backgroundColor: '#1A1A1A',
    paddingLeft: 5,
    paddingRight: 5,
    background: 'rgba(0,0,0,.66)',
  };

  const handleClick = () => {
    if (hasAccess && to) {
      if (to.substring(0, 4).toLowerCase() === 'http') {
        window.open(to, '_blank');
      } else {
        navigate(`/${to}`);
      }
    }
  };

  return (
    <Card
      sx={cardStyle}
      onClick={handleClick}
      onMouseOver={() => setIsHovered(true)}
      onMouseOut={() => setIsHovered(false)}
    >
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        <img
          src={image}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          alt={header}
        />
        <div style={overlayStyle}>
          <Typography variant={'h2'}>{header}</Typography>
        </div>
      </div>
    </Card>
  );
}

export { MediaCard };
